import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_CHART_THEME } from '@/constants/chartThemes';

interface ChartThemeStore {
  selectedTheme: string;
  setChartTheme: (themeId: string) => void;
}

export const useChartThemeStore = create(
  persist<ChartThemeStore>(
    (set) => ({
      selectedTheme: DEFAULT_CHART_THEME,
      setChartTheme: (themeId: string) => set({ selectedTheme: themeId }),
    }),
    {
      name: 'chart-theme-store',
    }
  )
);
